<template>
 <div class="custom-padding">
            <div class="container-fluid">
                
                <div class="row promocode" v-for="item in items" :key="item.id">
                    <div class="col-md-12 mb-4">
                        <i @click="backToCheckout()" style="margin-right:15px" class="fas fa-arrow-left"></i><span><i class="fas fa-percent custom-text-color percentage-icon mr-2"></i></span><span><b>OFFERS</b></span>
                    </div>
                    <!-- eslint-disable -->
                    <div class="col-md-6 col-lg-4 mb-5" v-for="offer in item[0].JSon3" :key="offer.id" v-if="offer.Context == 'OFFER'">
                    <!-- eslint-enable -->
                        <div class="card border-0 offer-box">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-3 pr-0 justify-content-center align-self-center">
                                        <!-- <img src="../assets/img/promocode/paytm.svg" class="img-fluid" alt="Responsive image"> -->
                                    </div>
                                    <div class="col-9 pr-0">
                                        <b>{{offer.header}}</b>
                                        <p class="mb-0 text-muted">{{offer.Description}}</p>
                                    </div>
                                    <div class="col-md-12">
                                        <hr />
                                    </div>
                                    <div class="col-md-12 text-center">
                                        <p class="mb-2"><span class="flat-text">{{offer.CouponCode}}</span></p>
                                        <span class="cCursorhover" @click="copyToClipboard(offer.CouponCode)">TAP TO COPY</span>
                                    </div>
                                    <div class="col-md-12">
                                        <hr class="mt-0" />
                                    </div>
                                    <div class="col-md-12">
                                        <div class="text-center">
                                            <b class="custom-text-color" data-toggle="modal" data-target="#promocodeModal">{{offer.TermsOfUse}}</b>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
        </div>
</template>

<script>
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
export default {
  data : function(){
      return {
      }
  },
    computed:{
      items() {
        return this.$store.state.items
      }
    },
    mounted(){
      this.$store.dispatch('loadItems')
    },
    methods : {
        copyToClipboard: function(coupon){
            this.$copyText(coupon)
        },
        backToCheckout: function(){
            this.$router.go(-1)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
